import Nullstack from 'nullstack';
export default function IconBadge4k({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-badge-4k",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "3",
    y: "5",
    width: "18",
    height: "14",
    rx: "2"
  }), "   ", Nullstack.element("path", {
    d: "M7 9v2a1 1 0 0 0 1 1h1"
  }), "   ", Nullstack.element("path", {
    d: "M10 9v6"
  }), "   ", Nullstack.element("path", {
    d: "M14 9v6"
  }), "   ", Nullstack.element("path", {
    d: "M17 9l-2 3l2 3"
  }), "   ", Nullstack.element("path", {
    d: "M15 12h-1"
  }), " ");
}